import {
  AvailableEnclosuresResponse,
  EnclosureProposition,
  EnclosurePropositionCreate,
} from '../models';

export class EnclosureMapper {
  static toEnclosurePropositions(
    availableEnclosures: AvailableEnclosuresResponse | null,
  ): EnclosureProposition[] {
    if (!availableEnclosures?.results?.length) {
      return [];
    }
    return availableEnclosures.results.map((proposition, index) => {
      const {
        enclosureId: _enclosureId,
        status,
        enclosureStatus,
        ...propositionWithoutId
      } = proposition;
      // TODO : remove it when backend will return enclosure status
      const resolvedStatus = status ?? enclosureStatus ?? 'feasible';

      void _enclosureId;
      return {
        ...propositionWithoutId,
        temporaryId: index + 1,
        enclosureStatus: resolvedStatus,
      };
    });
  }

  static prepareEnclosurePropositionsCreate(
    propositions: EnclosureProposition[],
  ): EnclosurePropositionCreate[] {
    return propositions.map(
      ({
        propositions: nestedPropositions,
        temporaryId: _temporaryId,
        ...rest
      }) => {
        void _temporaryId;

        return {
          totalPrice: rest.totalPrice,
          enclosureStatus: rest.enclosureStatus,
          error: rest.error,
          propositions: nestedPropositions.map(
            ({ cabinet, rack, unitPrice, quantity }) => ({
              unitPrice,
              quantity,
              cabinet: cabinet?.documentId,
              rack: rack?.documentId,
            }),
          ),
        };
      },
    );
  }
}
